<template>
  <loading-list v-if="viewData.loading"></loading-list>
  <main v-else role="main" class="col content-spacing">
    <b-container>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ `Dados ${state.name}` }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Usuários',
                href: '/#/consumers',
              },
              {
                text: 'Dados de um usuário',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row v-if="state">
        <b-col>
          <b-card
            style="margin-bottom: 10px"
            header-tag="header"
            v-if="state.firstApprovalSent"
          >
            <template #header>
              <h6 class="mb-0">
                Cadastro básico
                <a
                  @click="() => (viewData.showFirst = !viewData.showFirst)"
                  style="float: right"
                  href="javascript:void(0);"
                  >{{ viewData.showFirst ? 'esconder' : 'mostrar' }}</a
                >
              </h6>
            </template>
            <!-- <b-list-group v-if="viewData.showFirst">
              <b-list-group-item
                ><p style="font-weight: bold">
                  Foto da fatura
                  <a target="_blank" :href="state.billingUrl"
                    >Ver em outra aba</a
                  >
                </p>
                <p><img style="width: 100px" :src="state.billingUrl" /></p>
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">
                  Estado da fatura
                </p>
                {{ state.billingState }}
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">
                  Cidade da fatura
                </p>
                <p>{{ state.billingCity }}</p>
              </b-list-group-item>
            </b-list-group> -->

            <p
              class="card-text mt-2"
              v-if="viewData.showFirst && !state.firstApproval"
            >
              <b-button
                type="button"
                @click="() => approve('First')"
                variant="success"
                ><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>
                <i
                  v-if="viewData.loadingFirst"
                  class="fas fa-spinner fa-spin pull-right"
                ></i>
                <span v-else>Aprovar</span></b-button
              >
            </p>
          </b-card>

          <b-card
            style="margin-bottom: 10px"
            header-tag="header"
            v-if="state.secondApprovalSent"
          >
            <template #header>
              <h6 class="mb-0">
                Cadastro avançado
                <a
                  @click="() => (viewData.showSecond = !viewData.showSecond)"
                  style="float: right"
                  href="javascript:void(0);"
                  >{{ viewData.showSecond ? 'esconder' : 'mostrar' }}</a
                >
              </h6>
            </template>
            <b-list-group v-if="viewData.showSecond">
              <b-list-group-item
                ><p style="font-weight: bold">
                  Foto do documento
                  <a target="_blank" :href="state.documentUrl"
                    >Ver em outra aba</a
                  >
                </p>
                <p><img style="width: 100px" :src="state.documentUrl" /></p>
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold">
                  Selfie
                  <a target="_blank" :href="state.selfieUrl"
                    >Ver em outra aba</a
                  >
                </p>
                <p><img style="width: 100px" :src="state.selfieUrl" /></p>
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">CEP</p>
                {{ state.zipCode }}
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">Endereço</p>
                <p>
                  {{ state.address }} - {{ state.number }}, {{ state.city }} -
                  {{ state.state }} - {{ state.complement }}
                </p>
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">
                  Nacionalidade / Profissão / Estado Civil
                </p>
                <p>
                  {{ state.nationality }} /
                  {{ state.profession || 'Não informado' }} /
                  {{ getMaritalStatus(state.maritalStatus) }}
                </p>
              </b-list-group-item>
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">
                  Renda bruta mensal
                </p>
                <p>
                  {{ state.grossIncome | currency }}
                </p>
              </b-list-group-item>
            </b-list-group>

            <p
              class="card-text mt-2"
              v-if="viewData.showSecond && !state.secondApproval"
            >
              <BaseButtonComponent
                @click="() => approve('Second')"
                variant="confirmation-action"
                ><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>
                <i
                  v-if="viewData.loadingSecond"
                  class="fas fa-spinner fa-spin pull-right"
                ></i>
                <span v-else>Aprovar</span></BaseButtonComponent
              >
            </p>
          </b-card>

          <b-card
            style="margin-bottom: 10px"
            header="Pagamento"
            header-tag="header"
            v-if="state.finalApprovalSent"
          >
            <template #header>
              <h6 class="mb-0">
                Pagamento
                <a
                  @click="() => (viewData.showFinal = !viewData.showFinal)"
                  style="float: right"
                  href="javascript:void(0);"
                  >{{ viewData.showFinal ? 'esconder' : 'mostrar' }}</a
                >
              </h6>
            </template>
            <b-list-group v-if="viewData.showFinal">
              <b-list-group-item
                ><p style="font-weight: bold; margin-bottom: 5px">
                  Usa boleto? / Cartão de crédito
                </p>
                {{ state.useBankSlip ? 'Sim' : 'Não' }} /
                {{ state.creditCard }}
              </b-list-group-item>
            </b-list-group>

            <p
              class="card-text mt-2"
              v-if="viewData.showFinal && !state.finalApproval"
            >
              <BaseButtonComponent
                @click="() => approve('Final')"
                variant="confirmation-action"
                ><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>
                <i
                  v-if="viewData.loadingFinal"
                  class="fas fa-spinner fa-spin pull-right"
                ></i>
                <span v-else>Aprovar</span>
              </BaseButtonComponent>
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'users-edit',
  data: function() {
    return {
      state: {},
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        showFirst: false,
        showSecond: false,
        showFinal: false,
        loadingFirst: false,
        loadingSecond: false,
        loadingThird: false,
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    try {
      this.viewData.loading = true;

      const result = await API.post('/execute', {
        path: '/user/' + _id + '/consumer',
        method: 'get',
      });

      this.state = { ...result.model };

      this.viewData.loading = false;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }
  },
  methods: {
    getMaritalStatus(status) {
      if (status === 'single') {
        return 'Solteiro';
      } else if (status === 'married') {
        return 'Casado';
      } else if (status === 'divorced') {
        return 'Divorciado';
      } else {
        return 'Viúvo';
      }
    },
    async approve(path) {
      const _id = this.$route.params ? this.$route.params.id : 0;

      try {
        this.viewData[`loading${path}`] = true;

        const result = await API.post('/execute', {
          path: '/user/' + _id + '/consumer/' + path.toLowerCase(),
          method: 'put',
        });

        this.state[`${path.toLowerCase()}Approval`] = true;

        this.viewData[`loading${path}`] = false;

        this.$toast.success('Aprovado!');
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
    BaseButtonComponent,
  },
};
</script>
